import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const AirbnbCleaningPage = () => {
  const pageData = {
    pageTitle: "Airbnb Cleaning Cardiff | Turnover & Holiday Let Cleaning",
    metaDescription: "Airbnb and holiday let cleaning in Cardiff, Barry and Penarth. Turnover cleans between guests from £60, with linen changes and restocking on request. Request a free quote.",
    quoteService: "Airbnb Cleaning",
    heroImageAlt: "Before and after Airbnb bedroom turnover clean in Cardiff",
    
    heroTitle: "Airbnb & Holiday Let Cleaning in Cardiff",
    heroSubtitle: "Fast, reliable turnover cleaning for Cardiff hosts. Keep your guests happy and your calendar full with our professional Airbnb cleaning service.",
    heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/492ac19be1aa388f_1777632117444.png",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Running an Airbnb or holiday let in Cardiff? Our professional turnover cleaning service keeps your property guest-ready between bookings. We understand the importance of fast, reliable service that maintains 5-star cleanliness standards.
        </p>
        <p className="mb-4">
          Perfect for short-term rental hosts across Cardiff, Barry and Penarth, we offer flexible scheduling including same-day turnovers, weekend availability, and last-minute bookings. Our cleaners are trained specifically for vacation rental standards and know exactly what guests expect.
        </p>
        <p className="mb-4">
          We work with individual hosts and property management companies in our service areas. Optional extras include linen service, restocking essentials, and guest welcome preparation. All cleaners are DBS-checked, fully insured, and respect your property and guests' privacy.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Full Property Clean",
        description: "All rooms thoroughly cleaned, floors vacuumed and mopped, surfaces sanitized"
      },
      {
        title: "Kitchen Reset",
        description: "Clean all appliances, countertops, sink, empty bins, check supplies"
      },
      {
        title: "Bathroom Sanitization",
        description: "Deep clean toilet, shower, bath, sink, mirrors - guest-ready standard"
      },
      {
        title: "Bedroom Preparation",
        description: "Fresh linens (if provided), beds made, surfaces dusted, wardrobes checked"
      },
      {
        title: "Quality Check",
        description: "Final walkthrough ensuring everything is guest-ready and properly staged"
      },
      {
        title: "Guest Touches",
        description: "Towels arranged, remote controls positioned, welcome information displayed"
      }
    ],
    
    pricingInfo: {
      duration: "2-5 hours",
      price: "From £60",
      note: "Pricing based on property size. Studio/1-bed from £60, 2-bed from £75, 3-bed from £95. Add £15-20 for linen change service. Same-day turnovers may incur rush fee."
    },
    
    faqs: [
      {
        q: "How quickly can you turn around my property?",
        a: "We offer same-day turnover cleaning throughout Cardiff. Book us as soon as your guest checks out, and we'll have your property guest-ready for the next arrival. Standard turnover is 2-4 hours depending on property size."
      },
      {
        q: "Do you provide linen changing service?",
        a: "Yes! We can strip beds, replace linens, and make beds as part of the turnover. You can either provide fresh linens, or we can arrange linen rental service for you. This typically adds 15-30 minutes and £15-20 to the clean."
      },
      {
        q: "Can you restock guest supplies?",
        a: "Absolutely. We can check and restock toiletries, kitchen essentials, tea/coffee, and welcome packs. Just let us know what you'd like stocked, and we'll handle it during each turnover. Additional costs apply for supplies."
      },
      {
        q: "What if guests check out late or check in early?",
        a: "We're flexible! Let us know the checkout/check-in times, and we'll schedule accordingly. For very tight turnovers (less than 3 hours between guests), we may need to add a rush fee, but we'll always do our best to accommodate."
      },
      {
        q: "Do you work weekends and bank holidays?",
        a: "Yes, we operate 7 days a week including weekends and bank holidays. We understand Airbnb hosting doesn't stop for weekends - and neither do we. Weekend and holiday bookings are available at standard rates."
      }
    ],
    
    testimonial: {
      text: "The team provide photos and videos for peace of mind after all cleans, and they were able to change the timings of cleans last minute due to issues with the keys from my side, which was really appreciated. Most importantly, my guests have all noted that the apartment has been spotless after a NeatWave clean.",
      author: "Carlie Grainger, Airbnb host - Google review"
    },
    
    relatedServices: [
      {
        title: "Deep Cleaning",
        description: "Monthly deep clean to maintain high standards",
        url: "/deep-cleaning-cardiff"
      },
      {
        title: "End of Tenancy Cleaning",
        description: "Annual property refresh and deep clean",
        url: "/end-of-tenancy-cleaning-cardiff"
      },
      {
        title: "Regular Domestic Cleaning",
        description: "For longer-term rental properties",
        url: "/domestic-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default AirbnbCleaningPage;
